export default "__VITE_ASSET__s4fd5Wa2__"